import * as React from "react";
import { useCallback } from "react";
import capitalize from "lodash/capitalize";
import fixup from "views/pages/StyleFixups.css";
import { Col, Row } from "components/bootstrap";
import PageContentLayout from "components/layout/PageContentLayout";
import mergeParameterValues from "enterprise/parameters/logic/mergeParameterValues";
import ParameterInputForm from "./ParameterInputForm";
const humanReadableViewType = (viewType) => capitalize(viewType);
const RequiredParametersForViewForm = ({
  onSubmit = () => {
  },
  parameters,
  view: { type, title, search },
  executionState
}) => {
  const _onSubmit = useCallback(
    (newValues) => {
      const newExecutionState = mergeParameterValues(newValues, executionState);
      return onSubmit({ executionState: newExecutionState });
    },
    [executionState, onSubmit]
  );
  return /* @__PURE__ */ React.createElement(PageContentLayout, null, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 8, mdOffset: 3, className: fixup.bootstrapHeading }, /* @__PURE__ */ React.createElement("h1", null, humanReadableViewType(type), ": ", /* @__PURE__ */ React.createElement("em", null, title)), /* @__PURE__ */ React.createElement("p", null, "This ", humanReadableViewType(type).toLowerCase(), " uses parameters which need to be entered before it can be executed. Please enter the parameter values into the form.")), /* @__PURE__ */ React.createElement(ParameterInputForm, { parameters, searchId: search.id, onSubmit: _onSubmit })));
};
export default RequiredParametersForViewForm;
